let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ed4wU")).then(() => parcelRequire('2WniS'));